// App.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import {
  HomePage,
  AboutPage,
  ServicesPage,
  PortfolioPage,
  ProcessPage,
  TestimonialsPage,
  ContactPage
} from './pages/SitePages';
import ServiceDetail from './pages/ServiceDetail/ServiceDetail';
import ProjectDetail from './pages/ProjectDetail/ProjectDetail';
import NotFound from './pages/NotFound/NotFound';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import './styles/polish.css';
function App() {
  const [budgetData] = useState({
    selectedServices: [],
    total: 0
  });

  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <div className="animated-bg">
          <div className="bg-grid"></div>
        </div>
        <Navbar />
         <ToastContainer position="top-right" autoClose={3000} />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/portfolio/:slug" element={<ProjectDetail />} />
          <Route path="/process" element={<ProcessPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/contact" element={<ContactPage budgetData={budgetData} />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
